export default {
    antibiotic_class_1: 'Aminoglycosides',
    antibiotic_class_2: 'Anti-pseudomonal penicillin / Beta-lactamase inhibitors',
    antibiotic_class_3: 'Beta lactam / Beta-lactamase inhibitors',
    antibiotic_class_4: 'Carbapenems',
    antibiotic_class_5: 'Fluoroquinolones',
    antibiotic_class_6: 'Fourth-generation cephalosporins',
    antibiotic_class_7: 'Resistance to one or more antibiotics',
    antibiotic_class_8: 'Third-generation cephalosporins',
    antibiotic_class_9: 'Aminopenicillin',
    antibiotic_class_10: 'Extensive drug resistance in TB',
    antibiotic_class_11: 'Isoniazid mono-resistance',
    antibiotic_class_12: 'Macrolides',
    antibiotic_class_13: 'Methicillin',
    antibiotic_class_14: 'Multi-drug resistance excluding extensive drug resistance in TB',
    antibiotic_class_15: 'Multi-drug resistance in Salmonella enterica',
    antibiotic_class_16: 'Penicillin',
    antibiotic_class_17: 'Rifampicin mono-resistance',
    antibiotic_class_18: 'Trimethoprim-Sulfamethoxazole',
    antibiotic_class_19: 'Vancomycin',
    antibiotic_class_20: 'Not tested',
    antibiotic_class_21: 'Susceptible',
    antibiotic_class_22: 'Total',
    antibiotic_class_23: 'Resistant and Susceptible',
};
